import { createFeatureSelector, createSelector } from '@ngrx/store';

import { MapState } from './map.state';

const selectMapState = createFeatureSelector<MapState>('map');

export const getMapValues = createSelector(selectMapState, (mapState: MapState) => mapState?.values);
export const getMapTooltipState = createSelector(selectMapState, (mapState: MapState) => mapState?.tooltip);
export const isMapTooltipEnabled = createSelector(selectMapState, (mapState: MapState) => mapState?.tooltip.enabled);
export const getMapTooltipValue = createSelector(selectMapState, (mapState: MapState) => mapState?.tooltip.value);
export const getMapSelectedShop = createSelector(selectMapState, (mapState: MapState) => mapState?.selectedShop);
export const getMapParams = createSelector(selectMapState, (mapState: MapState) => mapState?.params);
